/**
 * Event Manager Constants
 * Shared configuration for event batching and flushing
 */

/** Events flush interval in milliseconds */
export const EVENTS_FLUSH_INTERVAL = 3000;

/** Maximum events queue size before auto-flush */
export const EVENTS_MAX_QUEUE_SIZE = 5;
